import styled, {css} from "styled-components"

const RedemptionFlowContainer = styled.div`
  padding-top: 150px;
  ${({theme}) => css`
    ${theme.mediaQueries.maxWidthMedia.desktop`
      padding-top: 75px;
    `}
    ${theme.mediaQueries.maxWidthMedia.tablet`
      padding-top: 50px;
    `}
  `}
`

export default RedemptionFlowContainer
